import React from 'react';
import { connect } from 'react-redux';
import { fetchEventDetails } from '../../actions/event';
import { sessionCheck } from '../../actions/user';
import Logger from '../../util/Logger';
import './ConcurrentSwitcher.css';
import { concurrentArrowNext, concurrentArrowPrevious } from '../../constants';
import Event from '../../models/Event';
import Collection from '../../models/Collection';
import { TopBarVisibility } from '../layout/TopBarVisibility';
import { CreatorReportAnalytics } from '../../analytics/CreatorReportAnalytics';

class ConcurrentSwitcher extends React.Component {

  constructor (props) {
    super(props);

    const { user, onSummaryClicked, onActiveEventChanged } = props;
    if (!user) {
      Logger.assert('Missing user in ConcurrentSwitcher component');
    }

    if (!onSummaryClicked) {
      Logger.assert('Missing onSummaryClicked callback in ConcurrentSwitcher component');
    }

    if (!onActiveEventChanged) {
      Logger.assert('Missing onActiveEventChanged callback in ConcurrentSwitcher component');
    }
  }

  render () {
    const { editing, user, event, collection, showSummary, onSummaryClicked, onActiveEventChanged } = this.props;
    if (!event || editing) {
      return null;
    } else {
      // Load event view if we are a concurrent collection
      if (TopBarVisibility.isShowingConcurrentSwitcher(event, collection)) {
        return <Switcher
          user={ user }
          event={ event }
          collection={ collection }
          showSummary={ showSummary }
          onSummaryClick={ onSummaryClicked }
          onChange={ onActiveEventChanged } />;
      } else {
        // Hide ribbon for not user created
        return null;
      }
    }
  }

}

const BUBBLES_PER_PAGE = 20

class Switcher extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      paginationOffset: 0
    }
  }

  jumpToSummary = () => {
    const { collection, onSummaryClick } = this.props;
    onSummaryClick(collection);
  };

  jumpToEventIndex = (index, fromArrows) => {
    const { event, collection, onChange, scrollPercentage } = this.props;

    this.paginate(index)
    const events = Collection.getEvents(collection);
    const eventCount = events.length;

    const currentEventId = Event.getId(event);
    let next = false;
    let previous = false;
    for (let i = 0; i < eventCount; ++i) {
      // Find the event we are currently on
      const e = events[i];
      if (Event.getId(e) === currentEventId) {
        if (index > i) {
          next = true;
        }

        if (index < i) {
          previous = true;
        }
        break;
      }
    }

    const jumpToEventAtIndex = (index >= 0 && index < events.length) ? index : -1;
    if (jumpToEventAtIndex < 0 || jumpToEventAtIndex >= events.length) {
      Logger.warn(`Cannot jump to event at index: ${index} out of bounds`);
    } else {
      Logger.info('Jump to event at index: ', jumpToEventAtIndex);
      const newEvent = events[jumpToEventAtIndex];

      const hero = Event.isUserCreated(event);
      if (!!fromArrows) {
        // If this click came from arrows track differently
        // Analytics index is 1 indexed
        CreatorReportAnalytics.concurrentSwitcherArrowClicked(index + 1, eventCount, next, previous, hero, scrollPercentage);
      } else {
        // Than if it came from buttons
        // Analytics index is 1 indexed
        CreatorReportAnalytics.concurrentSwitcherButtonClicked(index + 1, eventCount, next, previous, hero, scrollPercentage);
      }

      onChange(newEvent);
    }
  };

  clickArrowPrevious = (currentIndex) => {
    this.jumpToEventIndex(currentIndex - 1, true);
  };

  clickArrowNext = (currentIndex) => {
    this.jumpToEventIndex(currentIndex + 1, true);
  };

  paginate = (index) => {
    const paginationOffset = Math.floor( index / BUBBLES_PER_PAGE ) * BUBBLES_PER_PAGE
    this.setState({ paginationOffset })
  }

  handleArrowClicked = ($event, currentIndex, handler) => {
    $event.preventDefault();
    handler(currentIndex);
  };

  handleIndexClicked = ($event, index) => {
    $event.preventDefault();
    this.jumpToEventIndex(index, false);
  };

  handleSummaryClicked = ($event) => {
    $event.preventDefault();
    this.jumpToSummary();
  };

  render () {
    const { user, event, collection, showSummary } = this.props;
    const { paginationOffset: offset } = this.state;

    const isViewingAs = TopBarVisibility.isViewingAs(user);
    const isShowingHeroRibbon = TopBarVisibility.isShowingHeroRibbon(event);

    // Figure out the offset dynamically based on page content
    let offsetClass;
    if (isShowingHeroRibbon && isViewingAs) {
      offsetClass = 'viewing-as-and-navbar-and-hero-ribbon-offset';
    } else if (isShowingHeroRibbon) {
      offsetClass = 'navbar-and-hero-ribbon-offset';
    } else if (isViewingAs) {
      offsetClass = 'viewing-as-and-navbar-offset';
    } else {
      offsetClass = '';
    }

    const currentIndex = TopBarVisibility.getConcurrentBarCurrentIndex(event, collection);
    const events = Collection.getEvents(collection);
    return (
      <div className={ `row  no-gutters concurrent-switcher fixed-top ${offsetClass}` }>
        <div className="container">
          <div className="content h-100">
            <div className="row no-gutters h-100">

              <div className="col" />

              <div className="h-100 d-flex">
                <div className="row no-gutters h-100 m-auto">
                    <div className="summary d-flex m-2">
                      <div
                        onClick={ $event => this.handleSummaryClicked($event) }
                        className={ `h-100 m-auto chip ${showSummary
                          ? 'selected'
                          : ''}` }>
                        Summary
                      </div>
                    </div>
                </div>
              </div>

                <Arrow
                  isVisible={!showSummary && currentIndex > 0}
                  onClick={(event) => this.handleArrowClicked(event, currentIndex, this.clickArrowPrevious)}
                  arrow={concurrentArrowPrevious}
                />

                <Bubbles
                  events={events}
                  showSummary={showSummary}
                  currentIndex={currentIndex}
                  onClick={($event, i) => this.handleIndexClicked($event, i)}
                  offset={offset}
                  perPage={BUBBLES_PER_PAGE}
                />

                <Arrow
                  isVisible={!showSummary && currentIndex < events.length - 1}
                  onClick={(event) => this.handleArrowClicked(event, currentIndex, this.clickArrowNext)}
                  arrow={concurrentArrowNext}
                />
              <div className="col" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const Bubbles = ({ events: propEvents, offset, perPage, showSummary, currentIndex, onClick: propOnClick }) => {
  const isSelected = (i) => !showSummary && currentIndex === i

  const getClassName = (i) => `h-100 m-auto chip ${isSelected(i) ? "selected" : ""}`

  const onClick = (i) => (event) => {
    propOnClick(event, i)
  }

  const events = propEvents.slice(offset, offset + perPage)

  return (
    <div className="h-100 d-flex">
      <div className="row no-gutters h-100 m-auto">
        {events.map((e, index) => {
          const i = index + offset

          return (
            <div key={Event.getId(e)} className="concurrent-selection d-flex m-2">
            <div onClick={onClick(i)} className={getClassName(i)}>
              {i + 1}
            </div>
          </div>
          )
        })}
      </div>
    </div>
  )
}

const Arrow = ({ isVisible, onClick: onClickProp, arrow }) => {
  const className = `d-flex h-100 ${isVisible ? "" : "invisible"}`

  const onClick = (event) => {
    onClickProp(event)
  }

  return (
    <div className={className}>
      <i className="material-icons clickable m-auto" onClick={onClick}>
        {arrow}
      </i>
    </div>
  )
}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    loadingEvent: state.event.loading,
    eventError: state.event.error
    // event and collection are passed in from the parent component
  };
};

export default connect(mapStateToProps, { fetchEventDetails, sessionCheck })(ConcurrentSwitcher);
